import isShareLinkId from '../validation/is-share-link-id';
import throwError from '../error/throw';
import displayText from '../dom/display-text';
import fetchShareLink from '../http/fetch-share-link-by-share-id';
import isShareLinkUrl from '../validation/is-share-link-url';
import storeLink from '../storage/set-link';
import urlRedirect from '../url/redirect';

type T = (shareId: string) => Promise<void>;

const f: T = async (shareId) => {
    if (isShareLinkId(shareId) === false) {
        throwError(400, 'The share link is invalid');
    }

    displayText('Please wait....');

    const { id, url, systemId } = await fetchShareLink(shareId);

    if (isShareLinkUrl(url)) {
        throwError(400, 'The target url is invalid');
    }

    if (!url) return;

    if (systemId) {
        storeLink({ id, url, fetchCounter: 0 });
    }

    urlRedirect(url);
};

export default f;
